import DoneIcon from '@mui/icons-material/Done';
import UploadIcon from '@mui/icons-material/Upload';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { Box, Chip, Typography, Tooltip, Avatar, IconButton } from '@mui/material';


const descriptionInfo =
    'Details about the purchase including event name, venue, section, row, and seat information.';

const MAX_VISIBLE_TAGS = 5;

const TagChip = ({ label }) => (
    <Box
        component="span"
        sx={{
            display: 'inline-block',
            px: 0.9,
            py: 0.5,
            borderRadius: '16px',
            fontSize: '10px',
            border: '0.5px solid #1565c0',
            color: '#1565c0',
            backgroundColor: '#e3f2fd',
            mr: 0.5,
            mb: 0.25,
            mt: 0.5,
        }}
    >
        {label}
    </Box>
);



export const purchaseActivityTableHeaders = (onHeaderInfoClick, showTagsIcon, onSetAnchorEl) => {
    return [
        {
            id: 'purchased_at',
            label: 'Date',
            sort: false,
        },
        {
            id: 'purchase_id',
            label: 'Purchase',
            sort: false,
        },

        {
            id: 'description',
            label: (
                <Box display="flex" alignItems="center" gap={0.5}>
                    Description
                    {showTagsIcon?.company_pos ? (
                        <InfoOutlinedIcon
                            fontSize="small"
                            onClick={(e) => {
                                e.stopPropagation();
                                e.preventDefault();
                                onHeaderInfoClick({
                                    id: 'description',
                                    label: 'Description',
                                    description: descriptionInfo,
                                });
                            }}
                            sx={{
                                color: 'primary.main',
                                fontSize: '1rem',
                                ml: 0.5,
                                cursor: 'pointer',
                                '&:hover': {
                                    color: 'primary.dark',
                                },
                            }}
                        />
                    ) : null}
                </Box>
            ),
            sort: false,
            render: (row) => (
                <Box>
                    <Typography fontSize="12px">{`${row.description}${row.venue ? `, ${row.venue}` : ''
                        }`}</Typography>
                    <Typography fontSize="12px">{`${row.expires_at}, Section: ${row.class_1}, Row: ${row.class_2}, Seats: ${row.seats}`}</Typography>
                    {row.tags?.length > 0 && (
                        <Box sx={{ display: 'flex', flexWrap: 'wrap' }}>
                            {row.tags.slice(0, MAX_VISIBLE_TAGS).map((tag) => (
                                <TagChip key={tag.name} label={tag.name} />
                            ))}

                            {row.tags.length > MAX_VISIBLE_TAGS && (
                                <Tooltip
                                    title={
                                        <Box>
                                            {row.tags.slice(MAX_VISIBLE_TAGS).map((tag) => (
                                                <TagChip key={tag.name} label={tag.name} />
                                            ))}
                                        </Box>
                                    }
                                >
                                    <Box
                                        component="span"
                                        sx={{
                                            color: '#2e7d32',
                                            fontSize: '12px',
                                            cursor: 'pointer',
                                            alignSelf: 'center',
                                        }}
                                    >
                                        ...see more
                                    </Box>
                                </Tooltip>
                            )}
                        </Box>
                    )}
                </Box>
            ),
        },
        {
            id: 'transaction',
            label: 'Transaction',
            sort: false,
            render: (row) => (
                <Box>
                    <Typography fontSize="12px">
                        {row?.transaction_description
                            ? `${row.transaction_description} (${row.bank_name})`
                            : '-'}
                    </Typography>
                </Box>
            ),
        },
        {
            id: 'reference_id',
            label: 'Reference',
            sort: false,
        },
        {
            id: 'amount',
            label: 'Total',
            sort: false,
            render: (row) => `$${row.purchase_price}`,
        },
        {
            id: 'matchedBy',
            label: 'Matched By',
            sort: false,
            render: (row) =>
                row?.first_name ? (
                    <Tooltip
                        title={
                            <Typography
                                textAlign="center"
                                fontSize="12px"
                                sx={{ textAlign: 'center' }}
                            >
                                {row.first_name} {row.last_name}
                            </Typography>
                        }
                    >
                        <Avatar sx={{ width: 30, height: 30 }}>
                            <Typography fontSize="12px">
                                {row.first_name[0].toUpperCase()}
                                {row.last_name[0].toUpperCase()}
                            </Typography>
                        </Avatar>
                    </Tooltip>
                ) : (
                    <Typography fontSize="12px">-</Typography>
                ),
        },
        {
            id: 'plaidTransactionStatus',
            label: 'Status',
            sort: false,
            render: (row) => (
                <Chip
                    label={
                        row.matched_plaid_transaction || row.matched_payment_plan
                            ? 'Matched'
                            : 'Not matched'
                    }
                    sx={{
                        backgroundColor:
                            row.matched_plaid_transaction || row.matched_payment_plan
                                ? '#ECFDF3'
                                : '#FEF3F2',
                        color:
                            row.matched_plaid_transaction || row.matched_payment_plan
                                ? '#067647'
                                : '#B42318',
                        fontWeight: 500,
                        fontSize: '0.75rem',
                        lineHeight: '1.25',
                        padding: '2px 8px',
                        borderRadius: '16px',
                        '& .MuiChip-label': {
                            padding: 0,
                        },

                        border:
                            row.matched_plaid_transaction || row.matched_payment_plan
                                ? '1px solid #ABEFC6'
                                : '1px solid #FECDCA',
                        marginRight: '20px',
                    }}
                />
            ),
        },
        {
            id: 'action',
            label: '',
            sort: false,
            render: (row) => (
                <IconButton
                    onClick={(e) => {
                        e.stopPropagation();
                        onSetAnchorEl(e, row);
                    }}
                >
                    <MoreVertIcon />
                </IconButton>
            ),
        },
    ];
};
